import { t } from 'i18next';

import { ContextMenuItem } from '../../../../../../../react/components/skyview/context-menu';
import { isDefined } from '../../../../../../../utils/variables';
import { RevertChange } from '../../../../../../elements/design/design-node/design-node';
import { findFaceIdFromIntersection } from '../../../../../../elements/design/design-node/utils/face-node';
import { DesignTool } from '../../../../../design-tool';
import { addAndCommitAction } from '../../utils/actions';

function getFaceIdFromIntersection(tool: DesignTool) {
  const id = findFaceIdFromIntersection(tool.asset.designNode, tool.intersection);
  return isDefined(id) ? [id] : [];
}

export const flipFace = (tool: DesignTool): ContextMenuItem => {
  const faceIds =
    tool.currentSelection.faces.length > 0
      ? [...tool.currentSelection.faces]
      : getFaceIdFromIntersection(tool);

  const disabled = faceIds.length === 0;

  return {
    title: t('contextMenu.flipTriangle', { ns: 'skyviewDesign', count: faceIds.length }),
    action: () => {
      let changes: RevertChange[] = [];

      addAndCommitAction(tool, {
        commit: () => {
          if (disabled) {
            return;
          }

          changes = [];

          const faces = faceIds.map((x) => tool.asset.designNode.getFaceById(x));

          for (const face of faces) {
            changes.unshift(
              tool.asset.designNode.upsertFace({
                id: face.id,
                values: [face.values[2], face.values[1], face.values[0]],
              }),
            );
          }

          tool.asset.designNode.refresh();
          tool.asset.refreshMetadata();
        },
        rollback: () => {
          tool.asset.designNode.revert(changes);
          tool.asset.designNode.refresh();
          tool.asset.refreshMetadata();
        },
      });
      tool.contextMenuCallback?.();
    },
    disabled,
  };
};

// const updateFace = (tool: DesignTool, face: GeometryItem, newValues: number[]) => {
//   const faceIndices = tool.geometry.mesh.geometry.getIndex() as Uint16BufferAttribute;
//   faceIndices.setX(face.startIndex, newValues[0]);
//   faceIndices.setY(face.startIndex, newValues[1]);
//   faceIndices.setZ(face.startIndex, newValues[2]);
// };
